import BOSAlert from 'Components/Generic/Misc/BOSAlert';
import PropTypes from 'prop-types';

const BOSDeleteAlert = ({ ...props }) => {
  return <BOSAlert icon='trash' intent={'danger'} {...props} />;
};

BOSDeleteAlert.propTypes = {
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  isOpen: PropTypes.bool,
  closeFunc: PropTypes.func,
  onConfirm: PropTypes.func,
  contentTitle: PropTypes.string,
  content: PropTypes.node,
};

export default BOSDeleteAlert;
